import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  CardHeader,
} from "reactstrap";
import { toast } from "react-toastify";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ProductionFilmPDF from "./ProductionFilmPDF";
import { MOCK_PRODUCTION_FILM_DATA } from "./mockProductionFilm";
import MonthlyRequirementForm from "../AdvancedAnalysis/MonthlyRequirementForm";
const MachineDummyStatus = ({ selectedDate, selectedShift, selectedMachine }) => {
  const [stopTimes, setStopTimes] = useState([]);
  const [splits, setSplits] = useState({});
  const [singleData, setSingleData] = useState({});
   const authToken = localStorage.getItem("access");
    const [isLoading, setIsLoading] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  /* ---------------- FETCH STOP TIMES ---------------- */
  const fetchStopTimes = async () => {
    if (!selectedMachine || !selectedDate || !selectedShift) return;

    const res = await fetch(
      `https://api.hanoch.in/production-film/stopped-time/?machine_id=${selectedMachine}&date=${selectedDate}&shift=${selectedShift}`
    );
    const data = await res.json();
    setStopTimes(data?.stopped_times || []);
  };

 useEffect(() => {
    if (selectedDate && selectedShift&& selectedMachine) {
      handlePreview();
    }
  }, [selectedDate, selectedShift, selectedMachine]);

  useEffect(() => {
    fetchStopTimes();
  }, [selectedMachine, selectedDate, selectedShift]);

  /* ---------------- NO SPLIT SUBMIT ---------------- */
  const submitSingle = async (time) => {
    const data = singleData[time.id];
    if (!data?.reason || !data?.comment) {
      toast.error("Fill reason and comment");
      return;
    }

    const fd = new FormData();
    fd.append("id", time.id);
    fd.append("start_time", time.start_time);
    fd.append("end_time", time.end_time);
    fd.append("reason", data.reason);
    fd.append("comments", data.comment);
    fd.append("operator", 1);

    await fetch(
      "https://api.hanoch.in/production-film/update-stop-reason/",
      { method: "PATCH", body: fd }
    );

    toast.success("Saved");
    fetchStopTimes();
  };

  /* ---------------- INIT SPLIT ---------------- */
  const initSplit = (time) => {
    setSplits((prev) => ({
      ...prev,
      [time.id]: {
        start: time.start_time,
        end: time.end_time,
        segments: [
          {
            start: time.start_time,
            end: "",
            reason: "",
            comment: "",
          },
          {
            start: "",
            end: time.end_time,
            reason: "",
            comment: "",
          },
        ],
      },
    }));
  };

  /* ---------------- UPDATE END TIME ---------------- */
  const updateEndTime = (timeId, index, value) => {
    setSplits((prev) => {
      const split = prev[timeId];
      const segments = [...split.segments];
      const current = segments[index];

      if (value <= current.start || value > split.end) {
        toast.error("Invalid time range");
        return prev;
      }

      current.end = value;

      if (segments[index + 1]) {
        segments[index + 1].start = value;
      }

      return {
        ...prev,
        [timeId]: { ...split, segments },
      };
    });
  };

  /* ---------------- ADD SPLIT ---------------- */
  const addSplit = (timeId) => {
    setSplits((prev) => {
      const split = prev[timeId];
      const segments = [...split.segments];
      const last = segments[segments.length - 1];

      if (!last.start || last.start === split.end) {
        toast.error("Nothing left to split");
        return prev;
      }

      segments.pop();

      segments.push({
        start: last.start,
        end: "",
        reason: "",
        comment: "",
      });

      segments.push({
        start: "",
        end: split.end,
        reason: "",
        comment: "",
      });

      return {
        ...prev,
        [timeId]: { ...split, segments },
      };
    });
  };

  /* ---------------- UPDATE SEGMENT ---------------- */
  const updateSegment = (timeId, index, field, value) => {
    setSplits((prev) => {
      const segments = [...prev[timeId].segments];
      segments[index][field] = value;
      return { ...prev, [timeId]: { ...prev[timeId], segments } };
    });
  };

  /* ---------------- SUBMIT SPLITS ---------------- */
  const submitSplits = async (time) => {
    const split = splits[time.id];
    const last = split.segments[split.segments.length - 1];

    if (last.start !== last.end) {
      toast.error("Incomplete time coverage. Resetting.");
      setSplits((p) => {
        const c = { ...p };
        delete c[time.id];
        return c;
      });
      return;
    }

    for (let seg of split.segments) {
      if (!seg.reason || !seg.comment) {
        toast.error("Fill all reasons & comments");
        return;
      }
    }

    for (let seg of split.segments) {
      const fd = new FormData();
      fd.append("id", time.id);
      fd.append("start_time", seg.start);
      fd.append("end_time", seg.end);
      fd.append("reason", seg.reason);
      fd.append("comments", seg.comment);
      fd.append("operator", 1);

      await fetch(
        "https://api.hanoch.in/production-film/update-stop-reason/",
        { method: "PATCH", body: fd }
      );
    }

    toast.success("All splits submitted");
    fetchStopTimes();
  };
const submitStopReason = async (time) => {
  let payloadSplits = [];

  // ---------- SPLIT CASE ----------
  if (splits[time.id]) {
    const split = splits[time.id];
    const last = split.segments[split.segments.length - 1];
console.log("laststart",last.start,last.end)

    // Validate full coverage
  if (last.end !== time.end_time){
      toast.error("Incomplete time coverage");
      return;
    }

    for (let seg of split.segments) {
      if (!seg.reason || !seg.comment) {
        console.log("seggg",seg.reason,seg.comment)
        toast.error("Fill all reasons & comments");
        return;
      }

      payloadSplits.push({
        start_time: seg.start,
        end_time: seg.end,
        reason: seg.reason,
        comments: seg.comment,
      });
    }
  }

  // ---------- NON-SPLIT CASE ----------
  else {
    const data = singleData[time.id];
    if (!data?.reason || !data?.comment) {
      toast.error("Fill reason and comment");
      return;
    }

    payloadSplits.push({
      start_time: time.start_time,
      end_time: time.end_time,
      reason: data.reason,
      comments: data.comment,
    });
  }

  // ---------- FINAL PAYLOAD ----------
  const payload = {
    id: time.id,
    operator: 1,
    splits: payloadSplits,
  };

  try {
    await fetch(
      "https://api.hanoch.in/production-film/stop-reason-split/",
      {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    //toast.success("Stop reason saved");
    fetchStopTimes();

    // cleanup
    setSplits((p) => {
      const c = { ...p };
      delete c[time.id];
      return c;
    });

  } catch (err) {
    toast.error("Submission failed");
  }
};
  const handlePreview = async () => {
    if (!selectedDate || !selectedShift ||!selectedMachine) {
      toast.error("Please select date, shift and machine.");
      return;
    }

    // const today = new Date().toISOString().split("T")[0];
    // const currentShift = getCurrentShift();
    const formattedDate = new Date(selectedDate).toISOString().split("T")[0];

    // if (formattedDate === today && parseInt(selectedShift) === currentShift) {
    //   toast.error("Current shift report is only available after the shift ends.");
    //   return;
    // }
    const url = `https://api.hanoch.in/production-film/generate-production-pdf/?date=${formattedDate}&shift=${selectedShift}&machine=${selectedMachine}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch report.");
      }

      const blob = await response.blob();
      const pdfUrl = window.URL.createObjectURL(blob);
      setPdfBlobUrl(pdfUrl); // Save it to state

    } catch (error) {
      console.error("Error previewing report:", error);
      toast.error("Failed to preview report.");
    }
  };

 

  const handleDownload = () => {
    if (!pdfBlobUrl) {
      toast.error("Please preview the report first.");
      return;
    }

    const formattedDate = new Date(selectedDate).toISOString().split("T")[0];
    const link = document.createElement("a");
    link.href = pdfBlobUrl;
    link.setAttribute(
      "download",
      `Report_${formattedDate}_Shift${selectedShift}_Machine${selectedMachine}.pdf`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  /* ---------------- UI ---------------- */
  return (
    <>
    <Col xl={6}>
      <Card>
        <CardHeader>Production Film</CardHeader>
        <CardBody>
          {stopTimes.map((time) =>
            splits[time.id] ? (
              <div key={time.id} className="border p-3 mb-3">
                {splits[time.id].segments.map((seg, idx) => (
                  <Row key={idx} className="mb-2">
                    <Col md={3}>
                      <input
                        className="form-control"
                        value={`${seg.start} - ${seg.end || "??"}`}
                        disabled
                      />
                    </Col>

                    <Col md={2}>
                      <input
                        type="time"
                        step="1"
                        className="form-control"
                        disabled={
                          idx !== splits[time.id].segments.length - 2
                        }
                        onChange={(e) =>
                          updateEndTime(time.id, idx, e.target.value)
                        }
                      />
                    </Col>

                    <Col md={3}>
                      <select
                        className="form-control"
                        onChange={(e) =>
                          updateSegment(time.id, idx, "reason", e.target.value)
                        }
                      >
                        <option value="">Reason</option>
                        <option>Breakdown</option>
                        <option>Changeover</option>
                        <option>Material</option>
                        <option>People</option>
                        <option>Planned</option>
                      </select>
                    </Col>

                    <Col md={3}>
                      <input
                        className="form-control"
                        placeholder="Comment"
                        onChange={(e) =>
                          updateSegment(
                            time.id,
                            idx,
                            "comment",
                            e.target.value
                          )
                        }
                      />
                    </Col>
                  </Row>
                ))}

                <Button size="sm" onClick={() => addSplit(time.id)}>
                  Add Split
                </Button>{" "}
                <Button
  size="sm"
  color="success"
  onClick={() => submitStopReason(time)}
>
  Submit
</Button>

              </div>
            ) : (
              <div key={time.id} className="border p-3 mb-3">
                <b>
                  ⏱ {time.start_time} - {time.end_time}
                </b>

                <Row className="mt-2">
                  <Col md={3}>
                    <select
                      className="form-control"
                      onChange={(e) =>
                        setSingleData((p) => ({
                          ...p,
                          [time.id]: {
                            ...p[time.id],
                            reason: e.target.value,
                          },
                        }))
                      }
                    >
                      <option value="">Reason</option>
                      <option>Breakdown</option>
                      <option>Changeover</option>
                      <option>Material</option>
                      <option>People</option>
                      <option>Planned</option>
                    </select>
                  </Col>

                  <Col md={4}>
                    <input
                      className="form-control"
                      placeholder="Comment"
                      onChange={(e) =>
                        setSingleData((p) => ({
                          ...p,
                          [time.id]: {
                            ...p[time.id],
                            comment: e.target.value,
                          },
                        }))
                      }
                    />
                  </Col>

                  <Col md={2}>
                   <Button
  size="sm"
  color="success"
  onClick={() => submitStopReason(time)}
>
  Submit
</Button>

                  </Col>

                  <Col md={2}>
                    <Button
                      color="warning"
                      size="sm"
                      onClick={() => initSplit(time)}
                    >
                      Split
                    </Button>
                  </Col>
                </Row>
              </div>
            )
          )}
        </CardBody>
      </Card>
    </Col>
        <Col xl={6} >
             {isLoading ? (
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <>
            {pdfBlobUrl && (
              <div style={{ height: "1050px", marginTop: "20px" }}>
                <iframe
                  src={pdfBlobUrl}
                  width="100%"
                  height="100%"
                  title="PDF Preview"
                  style={{ border: "none" }}
                ></iframe>
              </div>
            )}
            </>
          )}
          </Col>
            {/* <Col md={6}>
                           <PDFDownloadLink
          document={<ProductionFilmPDF data={MOCK_PRODUCTION_FILM_DATA} />}
          fileName="production-film.pdf"
        >
          {({ loading }) =>
            loading ? "Generating PDF..." : "Download Production Film"
          }
        </PDFDownloadLink></Col> */}
     {/* <PDFDownloadLink
          document={<ProductionFilmPDF data={MOCK_PRODUCTION_FILM_DATA} />}
          fileName="production-film.pdf"
        >
          Download Test PDF
        </PDFDownloadLink> */}







    </>
  );
};

export default MachineDummyStatus;
